import { PencilSimple } from '@phosphor-icons/react';

export default PencilSimple;
